import { useEffect } from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { API } from "@/lib/api";

export default function PaymentCancel() {
  useEffect(() => {
    // Paiement désactivé (prod) → on ne laisse pas traîner cette page
    fetch(`${API}/public/config`).then((r) => r.json()).then((d) => {
      if (!d.payments_enabled) window.location.replace("/");
    }).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0B10] text-white flex items-center justify-center p-6" data-testid="payment-cancel-page">
      <div className="w-full max-w-md border border-white/10 rounded-2xl p-10 text-center bg-white/[0.03]">
        <XCircle className="w-14 h-14 text-[#E74C3C] mx-auto mb-6" />
        <h1 className="font-serif text-2xl mb-3" data-testid="payment-cancel-title">Paiement annulé</h1>
        <p className="text-sm text-[#A0B2CE] mb-8">
          Aucun montant n'a été débité. Votre facture reste disponible dans l'onglet
          « À payer » de votre espace client.
        </p>
        <Link to="/espace-client" data-testid="cancel-back-link"
          className="inline-flex items-center gap-2 bg-gold text-[#0A0B10] px-6 py-2.5 rounded-full font-mono text-[11px] uppercase tracking-[0.12em] hover:bg-[#B5952F] transition-colors">
          Retour à mon espace
        </Link>
      </div>
    </div>
  );
}
